/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Failed_To_UpdateInputs */

const en_samples_failed_to_update = /** @type {(inputs: Samples_Failed_To_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update samples`)
};

const es_samples_failed_to_update = /** @type {(inputs: Samples_Failed_To_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar muestras`)
};

/**
* | output |
* | --- |
* | "Failed to update samples" |
*
* @param {Samples_Failed_To_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_failed_to_update = /** @type {((inputs?: Samples_Failed_To_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Failed_To_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_failed_to_update(inputs)
	return es_samples_failed_to_update(inputs)
});